<template>
    <div class="phone-input">
        <b-form-input
            v-bind="$attrs"
            :value="value"
            type="tel"
            inputmode="tel"
            :autocomplete="autocomplete"
            :required="required"
            :state="resolvedState"
            v-on="forwardedListeners"
            @input="onInput"
            @blur="onBlur"
            @paste="onPaste"
        ></b-form-input>
        <b-form-invalid-feedback v-if="showFeedback" :state="resolvedState">
            {{ validationError }}
        </b-form-invalid-feedback>
    </div>
</template>

<script>
import {formatPhoneInput, phoneValidationError} from '@/utils/phone';

export default {
    name: 'PhoneInput',
    inheritAttrs: false,
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        mode: {
            type: String,
            default: 'primary',
            validator(value) {
                return ['primary', 'contact'].indexOf(value) !== -1;
            }
        },
        required: {
            type: Boolean,
            default: false
        },
        state: {
            type: Boolean,
            default: null
        },
        autocomplete: {
            type: String,
            default: 'tel'
        },
        showFeedback: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            touched: false
        };
    },
    computed: {
        forwardedListeners() {
            const listeners = Object.assign({}, this.$listeners);
            delete listeners.input;
            delete listeners.blur;
            delete listeners.paste;
            return listeners;
        },
        validationError() {
            return phoneValidationError(this.value, {
                mode: this.mode,
                required: this.required
            });
        },
        resolvedState() {
            if (this.state !== null) {
                return this.state;
            }
            if (!this.touched) {
                return null;
            }
            return this.validationError ? false : true;
        }
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
            this.$emit('validation', phoneValidationError(value, {
                mode: this.mode,
                required: this.required
            }));
        },
        onBlur(event) {
            this.touched = true;
            const nextValue = formatPhoneInput(this.value, this.mode);
            if (nextValue !== String(this.value || '')) {
                this.$emit('input', nextValue);
            }
            this.$emit('blur', event);
            this.$emit('validation', phoneValidationError(nextValue, {
                mode: this.mode,
                required: this.required
            }));
        },
        onPaste(event) {
            this.touched = true;
            const clipboard = event && event.clipboardData;
            const pastedValue = clipboard && clipboard.getData('text');
            if (pastedValue) {
                event.preventDefault();
                const nextValue = formatPhoneInput(pastedValue, this.mode);
                this.$emit('input', nextValue);
                this.$emit('validation', phoneValidationError(nextValue, {
                    mode: this.mode,
                    required: this.required
                }));
            }
            this.$emit('paste', event);
        }
    }
};
</script>

<style scoped>
.phone-input {
    min-width: 0;
    width: 100%;
}
</style>
